import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { apiConfiguration } from '../app.config';
import { MyAccountService } from '../services/my-account.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  const myAccountService = inject(MyAccountService);

  if (apiConfiguration.urlAuth.some(value => req.url.includes(value))) {

    const token = myAccountService.isAutenticated() ? myAccountService.getToken()?.trim() : "";

    const clonedRequest = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      }
    });

    return next(clonedRequest);

  } else {
    return next(req);
  }

};
